import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "flex-1 px-2 space-y-3",
  "aria-label": "Store sidebar"
}
const _hoisted_2 = {
  class: "space-y-1",
  role: "group"
}

import { computed } from 'vue'
import { useStore } from 'vuex'

import { buildStoreEditorSections } from '@/config/storeEditorSections'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'StoreSectionsNav',
  props: ['storeId'],
  setup(__props) {

const props = __props
const vuexStore = useStore()

const storeData = computed(() => mapRelationship({ type: 'store', id: props.storeId }))
const isCatering = computed(() => storeData.value?.attributes?.platform === 'catering')
const handle = computed(
  () => vuexStore.state.loggedInUser.attributes?.user_name || vuexStore.state.loggedInUser.attributes?.handle
)
const hasAnnouncements = computed(() =>
  vuexStore.state.loggedInUser?.attributes?.capabilities?.includes('announcements')
)

const sections = computed(() =>
  buildStoreEditorSections({
    hasAnnouncements: hasAnnouncements.value,
    handle: handle.value,
    isCatering: isCatering.value
  })
)

const sectionLink = link => `/store/stores/${props.storeId}#${link}`

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section) => {
      return (_openBlock(), _createElementBlock("div", {
        key: section.link,
        class: "space-y-1"
      }, [
        _createVNode(_component_router_link, {
          to: sectionLink(section.link),
          class: "w-full flex items-center rounded-md px-3 py-1 text-md font-bold tracking-tight text-gray-600 hover:bg-gray-50 hover:text-gray-900"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(section.name), 1)
          ]),
          _: 2
        }, 1032, ["to"]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.children, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.link,
              to: sectionLink(item.link),
              class: "w-full group flex items-center rounded-md px-3 py-1 text-sm font-medium tracking-tight text-gray-500 hover:bg-gray-50 hover:text-gray-900 truncate"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

}